import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { SecurityFacade } from '../../common/facade/SecurityFacade';
import { AuthService } from '../../auth.service';
import { AppInfo } from '../../common/model/dictionary/AppInfo';

@Component({
    selector: 'app-dashboard',
    templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit {
    private _urlToken: string;
    public loading = true;
    public errorToken = false;
    public errorUser = false;
    public messageLoader = 'Cargando...';
    private _urlBase: string;

    constructor(
        private appInfo: AppInfo,
        private router: Router,
        private route: ActivatedRoute,
        @Inject(DOCUMENT) private document: Document,
        private securityService: SecurityFacade,
        private authService: AuthService,
        @Inject('BASE_URL') baseUrl: string
    ) {
        this._urlBase = baseUrl;
     }

    ngOnInit() {
        if (this.route.snapshot.queryParamMap.get('tk')) {
            this._urlToken = this.route.snapshot.queryParamMap.get('tk');
            this.securityService.ValidateToken(this._urlToken).subscribe(
                response => {
                    if (response.completed) {
                        if (response.data == null) {
                            this.loading = false;
                            this.errorUser = true;
                        } else {
                            this.authService.login(this._urlToken, response.data.user, response.data.permissions, response.data.catDetLanguageId);
                            this.router.navigate(['/']);
                        }
                        
                    } else {
                        this.loading = false;
                        this.errorToken = true;
                    }
                },
                error => {
                    console.log(error);
                }
            );
        } else {
            this.document.location.href = this.gotoLogin();
        }
    }

    tryLogin() {
        this.loading = true;
        this.document.location.href = this.gotoLogin();
    }

    gotoLogin(): string {
        if (this._urlBase.includes(':9220')) {
            return this.appInfo.UrlLoginLocal;
        }
        if (this._urlBase.includes('qas')) {
            return this.appInfo.UrlLoginQas;
        }
        if (this._urlBase.includes('dev')) {
            return this.appInfo.UrlLoginDev;
        }
        return this.appInfo.UrlLoginProd;
    }
}
